export interface TabItem {
  id: string;
  label: string;
  count?: number;
}

interface TabsProps {
  tabs: TabItem[];
  active: string;
  onChange: (id: string) => void;
}

function Tabs({ tabs, active, onChange }: TabsProps) {
  return (
    <div className="flex flex-wrap gap-1 border-b border-zt-border">
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={[
              'relative flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors',
              isActive
                ? 'text-zt-accent'
                : 'text-zt-muted hover:text-slate-200',
            ].join(' ')}
          >
            {tab.label}
            {typeof tab.count === 'number' && (
              <span
                className={[
                  'rounded-full px-2 py-0.5 text-xs',
                  isActive ? 'bg-zt-primary/15 text-zt-primary' : 'bg-zt-elevated text-zt-muted',
                ].join(' ')}
              >
                {tab.count}
              </span>
            )}
            {isActive && (
              <span className="absolute inset-x-0 -bottom-px h-0.5 rounded-full bg-zt-primary" />
            )}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
